module.exports = __webpack_public_path__ + "media/images/top/scene01-9d7d03fda89b2c364873a1a35199e41a.jpg";